import React from "react";
import AppDialog from "components/AppDialog";
import { Button } from "components/ui/button";

function DeleteSearchDialog({ search, onDelete, onCancel }) {
  return (
    <AppDialog
      open={!!search}
      onOpenChange={(open) => {
        if (!open) {
          onCancel();
        }
      }}
      onClose={onCancel}
      header={`Delete "${search?.title}"`}
      className="w-full max-w-md overflow-hidden rounded-lg"
      contentClassName="px-6 pb-6 pt-4"
    >
      <p className="font-inter text-base font-normal text-slate-700">
        Are you sure you want to delete &quot;{search?.title}&quot;?
      </p>

      <div className="mt-6 flex justify-end gap-2.5">
        <Button type="button" variant="outline" onClick={onCancel}>
          Cancel
        </Button>
        <Button
          type="button"
          className="bg-red-600 text-white hover:bg-red-700"
          onClick={() => onDelete(search.id)}
        >
          Delete It
        </Button>
      </div>
    </AppDialog>
  );
}

export default DeleteSearchDialog;
